import { LockFill } from '@gravity-ui/icons';

import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import { UserFlow } from '@/types';

import MethodSwitchButton from './MethodSwitchButton';

type Props = {
  readonly className?: string;
};

const PasswordSignInLink = ({ className }: Props) => {
  const navigate = useNavigateWithPreservedSearchParams();

  return (
    <MethodSwitchButton
      className={className}
      icon={<LockFill />}
      text="action.sign_in_via_password"
      onClick={() => {
        navigate(`/${UserFlow.SignIn}/password`, { replace: true });
      }}
    />
  );
};

export default PasswordSignInLink;
